<div style="display: flex">
	<mat-dialog-content>
		<div class="icon-legend-row">
			<div class="icon-legend-item icon-legend-set-width">
				<mat-icon svgIcon="sl-open-key-door" class="icon-legend-icon-right-padding"></mat-icon>
				<p>Device Access</p>
			</div>

			<div class="icon-legend-item icon-legend-set-width icon-legend-right-align">
				<mat-icon svgIcon="sl-remove-device" class="icon-legend-icon-right-padding"></mat-icon>
				<p>Remove Device</p>
			</div>
		</div>

		<div class="icon-legend-row">
			<div class="icon-legend-item icon-legend-set-width">
				<mat-icon svgIcon="sl-install-device" class="icon-legend-icon-right-padding"></mat-icon>
				<p>Install Device</p>
			</div>

			<div class="icon-legend-item icon-legend-set-width icon-legend-right-align">
				<mat-icon svgIcon="sl-shield-checkmark" class="icon-legend-icon-right-padding"></mat-icon>
				<p>Arm/Disarm Alarm</p>
			</div>
		</div>

		<div class="icon-legend-row">
			<div class="icon-legend-item icon-legend-set-width">
				<mat-icon svgIcon="sl-bell-crossed-out" class="icon-legend-icon-right-padding"></mat-icon>
				<p>Alarm Override</p>
			</div>
		</div>
	</mat-dialog-content>
</div>
